module.exports = __webpack_public_path__ + "media/images/sports_coaching/cover-mobile-6076a8885cf1acfa585b3d20d7d3dfc6.jpg";